import { NumberInput } from "react-admin";
import { Divider, Grid, Typography } from "@mui/material";

const AdditionalCapacityForm = ({ specialities, isState, summaries = {} }) => {
  return (
    <Grid
      container
      spacing={2}
    >
      {specialities.map((speciality, index) => (
        <Grid
          item
          xs={12}
          key={speciality.id}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
          >
            <Grid
              item
              xs={12}
              md={isState ? 4 : 8}
            >
              <Typography variant="body2">{speciality.name}</Typography>
              {summaries[speciality.id] && (
                <Typography
                  component="div"
                  variant="caption"
                  color="secondary"
                >
                  {`Приети: ${summaries[speciality.id].accepted?.total ?? 0} · Неприети: ${summaries[speciality.id].notAccepted?.total ?? 0
                    }`}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={6}
              md={isState ? 2 : 4}
            >
              <NumberInput
                source={`capacities.${index}.candidatesCapacity`}
                label="Брой места"
                min={1}
                step={1}
                helperText={false}
                fullWidth
              />
            </Grid>
            {isState && (
              <>
                <Grid
                  item
                  xs={4}
                  md={2}
                >
                  <NumberInput
                    source={`capacities.${index}.maleCapacity`}
                    label="Мъже"
                    min={0}
                    step={1}
                    helperText={false}
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  md={2}
                >
                  <NumberInput
                    source={`capacities.${index}.femaleCapacity`}
                    label="Жени"
                    min={0}
                    step={1}
                    helperText={false}
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  md={2}
                >
                  <NumberInput
                    source={`capacities.${index}.zvoCapacity`}
                    label="ЗВО"
                    min={0}
                    step={1}
                    helperText={false}
                    fullWidth
                  />
                </Grid>
              </>
            )}
          </Grid>
          {index < specialities.length - 1 && <Divider sx={{ marginTop: 2 }} />}
        </Grid>
      ))}
    </Grid>
  );
};

export default AdditionalCapacityForm;
